import Head from 'next/head'

import FAQTemplate from '~/components/templates/FAQTemplate'

const faq = () => {
  return (
    <>
      <Head>
        <title>よくある質問 | eduad</title>
        <meta
          name='description'
          content='eduad-エデュアド-は教育・スクール運営に特化したウェブマーケティング支援を行うプロフェッショナル技術者集団です。よくある質問をまとめました。'
        />
      </Head>
      <FAQTemplate />
    </>
  )
}

export default faq
